export default __webpack_public_path__ + "static/media/Nicole.d8a38c74.jpeg";